"use strict";

var _interopRequireWildcard = require("D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _regenerator2 = _interopRequireDefault(require("D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.search");
var _elementUi = _interopRequireWildcard(require("element-ui"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));
var _settings = require("@/settings");
var _user = require("@/api/user");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
// progress bar
// progress bar style
// get token from cookie

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ["".concat(_settings.roterPre, "/login"), '/auth-redirect']; // no redirect whitelist

// 处理 URL 参数中的 token（用于从 admin 端跳转免登录）
function handleUrlToken() {
  var urlParams = new URLSearchParams(window.location.search);
  var token = urlParams.get('token');
  if (token) {
    // 先更新 store 中的 token（确保立即生效）
    _store.default.commit('user/SET_TOKEN', token);
    // 设置 Cookie，使用父域名以便跨子域名共享
    _jsCookie.default.set('merchantToken', token, {
      domain: '.zszhenhuixuan.com',
      path: '/',
      expires: 1 // 1天过期
    });
    // 清除 URL 中的 token 参数，避免暴露
    urlParams.delete('token');
    var newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    // 使用 replaceState 清除URL参数，确保不会在浏览器历史中留下记录
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, document.title, newUrl);
    } else {
      // 如果 replaceState 不可用，使用 location.replace
      window.location.replace(newUrl);
    }
  }
}
_router.default.beforeEach(/*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(to, from, next) {
    var cookieToken, storeToken, isEdit, _storeToken, _cookieToken, hasToken;
    return (0, _regenerator2.default)().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          // 处理 URL 参数中的 token（优先处理，确保 token 已设置）
          handleUrlToken();

          // 确保 store 中的 token 已同步（如果 Cookie 中有但 store 中没有）
          cookieToken = _jsCookie.default.get('merchantToken');
          storeToken = _store.default.getters.token;
          if (cookieToken && !storeToken) {
            _store.default.commit('user/SET_TOKEN', cookieToken);
          }
          isEdit = _store.default.getters.isEdit; // if(from.name === 'AddProduct' || from.name === 'CreateSpikeGoods' || from.name === 'preSaleCreate' || from.name === 'assistProductCreate' || from.name === 'combinationCreate'){
          if (isEdit) {
            _elementUi.MessageBox.confirm('离开该编辑页面，已编辑信息会丢失，请问您确认离开吗？', '提示', {
              confirmButtonText: '离开',
              cancelButtonText: '不离开',
              confirmButtonClass: 'btnTrue',
              cancelButtonClass: 'btnFalse',
              type: 'warning'
            }).then(function () {
              // async() => {
              // }
              _store.default.dispatch('settings/setEdit', false);
              _nprogress.default.start();
              document.title = (0, _getPageTitle.default)(to.meta.title);
              // 优先从 store 读取，如果没有再从 Cookie 读取
              var storeToken = _store.default.getters.token;
              var cookieToken = _jsCookie.default.get('merchantToken');
              var hasToken = storeToken || cookieToken;
              // 如果 Cookie 中有但 store 中没有，同步到 store
              if (cookieToken && !storeToken) {
                _store.default.commit('user/SET_TOKEN', cookieToken);
              }
              if (hasToken) {
                if (to.path === "".concat(_settings.roterPre, "/login")) {
                  // if is logged in, redirect to the home page
                  next({
                    path: '/'
                  });
                  _nprogress.default.done();
                } else {
                  if (from.fullPath === '/' && from.path !== "".concat(_settings.roterPre, "/login")) {
                    (0, _user.editFormApi)().then(function (res) {
                      next();
                    }).catch(function (res) {
                      next();
                    });
                  } else {
                    next();
                  }
                }
              } else {
                /* has no token*/
                if (whiteList.indexOf(to.path) !== -1) {
                  // in the free login whitelist, go directly
                  next();
                } else {
                  // other pages that do not have permission to access are redirected to the login page.
                  // await store.dispatch('user/resetToken')
                  next("".concat(_settings.roterPre, "/login?redirect=").concat(to.path));
                  _nprogress.default.done();
                }
              }
            });
          } else {
            // start progress bar
            _nprogress.default.start();
            // set page title
            document.title = (0, _getPageTitle.default)(to.meta.title);

            // determine whether the user has logged in
            // 优先从 store 读取（因为 handleUrlToken 会更新 store），如果没有再从 Cookie 读取
            _storeToken = _store.default.getters.token;
            _cookieToken = _jsCookie.default.get('merchantToken');
            hasToken = _storeToken || _cookieToken; // 如果 Cookie 中有但 store 中没有，同步到 store
            if (_cookieToken && !_storeToken) {
              _store.default.commit('user/SET_TOKEN', _cookieToken);
            }

            // 调试信息：检查 token 来源
            if (!hasToken) {
              console.log('Token 检查失败:', {
                storeToken: _storeToken,
                cookieToken: _cookieToken,
                urlToken: new URLSearchParams(window.location.search).get('token')
              });
            }
            if (hasToken) {
              if (to.path === "".concat(_settings.roterPre, "/login")) {
                next({
                  path: '/'
                });
              } else {
                if (from.fullPath === '/' && from.path !== "".concat(_settings.roterPre, "/login")) {
                  (0, _user.editFormApi)().then(function (res) {
                    next();
                  }).catch(function (res) {
                    next();
                  });
                } else {
                  next();
                }
              }
            } else {
              if (whiteList.indexOf(to.path) !== -1) {
                next();
              } else {
                _store.default.dispatch('user/resetToken');
                next("".concat(_settings.roterPre, "/login?redirect=").concat(to.path));
                _nprogress.default.done();
              }
            }
            _store.default.dispatch('settings/setEdit', false);
          }
        case 1:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  _nprogress.default.done();
});